export default __webpack_public_path__ + "static/piano-animated-706e41a0feea802775faafb9c3f2855b.gif";